<div class="cm-landing-fixed-width cm-hero-section">
	<div class="cm-hero-section__left">
		<h1>
			About Us
		</h1>
		<p>
			We believe farmers shouldn’t have to choose between productivity
			and sustainability. CropManage brings science and technology
			together to help agriculture thrive with less.
		</p>
	</div>
	<div class="cm-hero-section__right">
		<img src="../../../../assets/images/photos/about-us.jpg" width="628"
			height="450"/>
	</div>
</div>

<div class="cm-landing-fixed-width cm-what-is-cropmanage">
	<div class="cm-what-is-cropmanage__left">
		<img src="../../../../assets/images/photos/tablet.png" width="612"
			height="369"/>
	</div>
	<div class="cm-what-is-cropmanage__content">
		<h2>What is CropManage?</h2>
		<p>
			CropManage is a free, web-based decision-support tool developed
			by UC Cooperative Extension to help growers make more informed
			irrigation and nutrient management decisions. Originally created
			for lettuce farmers, CropManage now supports over 40 crops and
			continues to expand based on grower input and new research.
		</p>
	</div>
</div>
<div class="cm-landing-fixed-width cm-what-is-cropmanage cm-our-mission-section">
	<div class="cm-what-is-cropmanage__content">
		<h2>Our Mission</h2>
		<p>
			We built CropManage to help growers cut costs and protect the
			environment. When farming degrades soil or pollutes water, it becomes
			harder to grow healthy crops year after year. Protecting natural
			resources helps ensure long-term food production, preserves
			groundwater quality, and conserves water in regions where it’s
			increasingly scarce.
		</p>
	</div>
	<div class="cm-our-mission__right">
		<img src="../../../../assets/images/photos/mason-and-cahn.jpg" width="538"
				height="377"/>
	</div>
</div>
<div class="cm-our-story-section">
	<div class="cm-landing-fixed-width">
		<h2>
			Our Story
		</h2>
		<p>
			CropManage launched in 2011 as a CDFA-FREP–funded project led by UC
			Cooperative Extension farm advisor Michael Cahn. The initial goal
			was to help lettuce farmers optimize
			irrigation and fertilizer use through soil nitrate quick tests
			and weather data from CIMIS, California's statewide weather data service.
		</p>
		<p>
			Since then, CropManage has broadened its scope to include
			vegetables, perennial fruit, and tree nuts such as almonds — all backed
			by years of UC research and field validation.
		</p>
		<!--
		<iframe width="560" height="315"
			src="https://www.youtube.com/embed/gc9FzUafw6w?si=Z3JeC3bhy54in4DY"
			title="YouTube video player" frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; 
			gyroscope; picture-in-picture; web-share"
			referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
		</iframe>
		-->

		<video 
			controls 
			playsinline 
			class="el-image" 
			uk-cover="" 
			poster="../../../../assets/images/photos/video thumb.png">
				<source src="../../../../assets/images/innovation-faire.mp4" type="video/mp4">
				Your browser does not support the video tag.
		</video>

	</div>
</div>
<div class="cm-landing-fixed-width cm-our-team-section">
	<div class="cm-our-team-header-section">
		<h2>
			Our Team
		</h2>
		<p>Behind CropManage is a team of University of California
			researchers, farm advisors, and software developers, working with
			collaborators from other institutions to turn science into reliable
			platform for water and nutrient management.
		</p>
	</div>
	<div class="cm-core-team">
		<h2>Core Team</h2>
		<div class="cm-core-team__member">
			<img src="../../../../assets/images/photos/people/michael.png" width="174" height="218"/>
			<div class="cm-core-team__member__bio">
				<div class="cm-team-member__name">Michael Cahn</div>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Monterey County
				</p>
				<p class="cm-team-member__title">
					Irrigation & Water Resources Advisor
				</p>
				<p class="cm-team-member__description">
					Michael leads the research and field validation
					that underpin CropManage. As an Irrigation and Water
					Resources Advisor with UC Cooperative Extension, Monterey
					County, he has spent over two decades studying irrigation
					and nutrient management in California agriculture.
				</p>
			</div>
		</div>
		<div class="cm-core-team__member">
			<img src="../../../../assets/images/photos/people/tetsuto.png" width="174" height="218"/>
			<div class="cm-core-team__member__bio">
				<div class="cm-team-member__name">Tetsuto Yabuki</div>
				<p class="cm-team-member__location">
					UC Agriculture and Natural Resources
				</p>
				<p class="cm-team-member__title">
					Project Lead & Developer
				</p>
				<p class="cm-team-member__description">
					Tetsuto leads the technical architecture and development
					of CropManage. With more than 30 years of programming
					experience and nearly a decade as the project’s lead
					developer, he implements algorithms, develops new
					features, and ensures that the platform is reliable and
					effective for growers and researchers.
				</p>
			</div>
		</div>
	</div>
	<div class="cm-other-teams">
		<h2>Advisory Committee</h2>
		<div class="cm-other-teams__members">
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/brenna.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Brenna Aegerter
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, San Joaquin County
				</p>
				<p class="cm-team-member__title">
					Farm Advisor
				</p>
				<a matTooltip="{{ people[0] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/khaled.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Khaled Bali
				</p>
				<p class="cm-team-member__location">
					Kearney Agricultural Research and Extension Center
				</p>
				<p class="cm-team-member__title">
					Irrigation Water Management Specialist
				</p>
				<a matTooltip="{{ people[1] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/Andre Biscaro.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Andre Biscaro
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Ventura County
				</p>
				<p class="cm-team-member__title">
					Irrigation and Water Resources Advisor
				</p>
				<a matTooltip="{{ people[16] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/mae.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Mae Culumber
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Fresno County
				</p>
				<p class="cm-team-member__title">
					Nut Crops Farm Advisor
				</p>
				<a matTooltip="{{ people[2] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/zheng.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Zheng Wang
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Stanislaus County
				</p>
				<p class="cm-team-member__title">
					Vegetable Crop Advisor
				</p>
				<a matTooltip="{{ people[9] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/mohammad.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Mohammad Yagmour
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Kern County
				</p>
				<p class="cm-team-member__title">
					Area Orchard Systems Advisor
				</p>
				<a matTooltip="{{ people[11] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/george.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Shijian Zhuang
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Fresno County
				</p>
				<p class="cm-team-member__title">
					Viticulture Farm Advisor
				</p>
				<a matTooltip="{{ people[21] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/joy.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Joy Hollingsworth
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Tulare County
				</p>
				<p class="cm-team-member__title">
					Table Grape Advisor
				</p>
				<a matTooltip="{{ people[19] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
		</div>
		<h2>Field Staff</h2>
		<div class="cm-other-teams__members">
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/David chambers.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					David Chambers
				</p>
				<p class="cm-team-member__title">
					Staff Research Associate II
				</p>
				<a matTooltip="{{ people[12] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/jorge.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Jorge Calva
				</p>
				<p class="cm-team-member__title">
					Staff Research Associate
				</p>
				<a matTooltip="{{ people[13] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/noe.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Noe Cardenas
				</p>
				<p class="cm-team-member__title">
					Lab Assistant I
				</p>
				<a matTooltip="{{ people[14] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
		</div>
		<h2>Contributors</h2>
		<div class="cm-other-teams__members">
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/Larry.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Larry Bettiga
				</p>
				<p class="cm-team-member__location">
					UCCE Monterey, San Benito, and Santa Cruz Counties
				</p>
				<p class="cm-team-member__title">
					Acting County Director & Viticulture Farm Advisor
				</p>
				<a matTooltip="{{ people[15] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/Aliasghar Montazar.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Aliasghar Montazar
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Riverside
				</p>
				<p class="cm-team-member__title">
					Irrigation and Water Management Advisor
				</p>
				<a matTooltip="{{ people[6] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/patrik.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Patrick Brown
				</p>
				<p class="cm-team-member__location">
					Department of Plant Sciences, UC Davis
				</p>
				<p class="cm-team-member__title">
					Distinguished Professor
				</p>
				<a matTooltip="{{ people[17] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/Tim.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Tim Hartz
				</p>
				<p class="cm-team-member__location">
					Department of Plant Sciences, UC Davis
				</p>
				<p class="cm-team-member__title">
					Professor Emeritus
				</p>
				<a matTooltip="{{ people[18] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/kenneth.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Kenneth Miller
				</p>
				<p class="cm-team-member__location">
					Formation Environmental
				</p>
				<p class="cm-team-member__title">
					Technical Program Manager, SSJV MPEP
				</p>
				<a matTooltip="{{ people[20] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/richard.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Richard Smith
				</p>
				<p class="cm-team-member__location">
					UC Cooperative Extension, Monterey County
				</p>
				<p class="cm-team-member__title">
					Vegetable Crop Production & Weed Science Advisor
				</p>
				<a matTooltip="{{ people[8] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/forrest.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Forrest Melton
				</p>
				<p class="cm-team-member__location">
					NASA Ames Research Center, Biospheric Science Branch
				</p>
				<p class="cm-team-member__title">
					Senior Research Scientist
				</p>
				<a matTooltip="{{ people[5] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/daniel.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Daniel Geissler
				</p>
				<p class="cm-team-member__location">
					Department of Land, Air, and Water Resources, UC Davis
				</p>
				<p class="cm-team-member__title">
					Assistant Cooperative Extension Specialist
				</p>
				<a matTooltip="{{ people[3] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/lee.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Lee Johnson
				</p>
				<p class="cm-team-member__location">
					NASA ARC-CREST, CSU Monterey Bay
				</p>
				<p class="cm-team-member__title">
					Senior Research Scientist
				</p>
				<a matTooltip="{{ people[4] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/Daniele.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Daniele Zaccaria
				</p>
				<p class="cm-team-member__location">
					Department of Land, Air and Water Resources, UC Davis
				</p>
				<p class="cm-team-member__title">
					Agricultural Water Management Specialist
				</p>
				<a matTooltip="{{ people[10] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
			<div class="cm-other-teams__member">
				<img src="../../../../assets/images/photos/people/joji.png" width="174" height="218"/>
				<p class="cm-team-member__name">
					Joji Muramoto
				</p>
				<p class="cm-team-member__location">
					UC ANR / UC Santa Cruz
				</p>
				<p class="cm-team-member__title">
					Cooperative Extension Specialist
				</p>
				<a matTooltip="{{ people[7] }}"
					[matTooltipClass]="'cm-verbose-v2'">READ MORE</a>
			</div>
		</div>
	</div>
	<div class="cm-cta">
		<span>
			Have questions about CropManage or our work?&nbsp;<a routerLink="/contact-us">
				Contact us
			</a>
		</span>
	</div>
</div>

<popper-content *ngFor="let person of people; let i = index" #personPopper>
    <div class="bk-popper">{{ person }}</div>
</popper-content>